import { hhmm } from '../../../compartido/formato';
import type { Hora } from '../../../compartido/tipos';

/**
 * La grilla de casillas de un día. Cada hora se prende o se apaga sola: se
 * permiten huecos. Las tomadas por otra persona van en gris y tachadas.
 */
export function GrillaHoras({
  casillas,
  libres,
  elegidas,
  onAlternar,
  maximo,
}: {
  casillas: Hora[];
  libres: Set<Hora>;
  elegidas: Hora[];
  onAlternar: (h: Hora) => void;
  /** Al reprogramar hay que elegir exactamente N: con N elegidas, el resto se apaga. */
  maximo?: number;
}) {
  const lleno = maximo !== undefined && elegidas.length >= maximo;
  return (
    <div className="horas" role="group" aria-label="Horas del día">
      {casillas.map((h) => {
        const marcada = elegidas.includes(h);
        const libre = libres.has(h);
        // Ocupada (la tomó otra persona) no es lo mismo que "sin cupo" (ya
        // elegiste todas las que te tocan): la primera va tachada; la
        // segunda solo atenuada, porque sigue libre.
        const sinCupo = libre && !marcada && lleno;
        return (
          <button
            key={h}
            type="button"
            className="hora"
            aria-pressed={marcada}
            disabled={!marcada && !libre}
            aria-disabled={sinCupo || undefined}
            aria-label={`${hhmm(h)} a ${hhmm(h + 1)}${!libre && !marcada ? ', ocupada' : ''}`}
            onClick={() => !sinCupo && onAlternar(h)}
          >
            {hhmm(h)}
          </button>
        );
      })}
    </div>
  );
}
